import api from '../../../App/socket';

export const getManagerLeads = (where) => {
    const order = {
        _id: -1,
    };

    return api
        .send(
            {
                api: 'db',
                model: 'Lead',
                action: 'Read',
                options: {
                    attributes: ['is_manager_special', 'customer_valuation', 'trade.is_trade', 'lead_pot', 'photos.picture', 'has_completed_blemish', 'completed_blemish_step', 'created_date', 'valuations.created_date', 'valuations.valuation', 'valuations.retail_price', 'valuations.created_date', 'marketing.ref_lead_affiliate', 'is_part_complete', 'is_duplicate', 'part_ex.is_part_ex'],
                    order,
                    include: [
                        {
                            model: 'Bike_lead',
                            path: 'ref_bike_lead',
                            attributes: ['mileage', 'vrm', 'unmaped_data.bike_model', 'unmaped_data.bike_cc', 'unmaped_data.bike_year'],
                            include: [
                                {
                                    model: 'Bike_brand',
                                    path: 'ref_bike_brand',
                                    attributes: ['name'],
                                },
                                {
                                    model: 'Bike_model',
                                    path: 'ref_bike_model',
                                    attributes: ['name', 'cc', 'model_variation'],
                                },
                                {
                                    model: 'Bike_variant',
                                    path: 'ref_bike_variant',
                                    attributes: ['year', 'current_stock_count', 'par_level', 'margin'],
                                },
                            ],
                        },
                        {
                            model: 'Lead_status',
                            path: 'ref_lead_status',
                            attributes: ['abbr', 'name'],
                        },
                        {
                            model: 'Lead_customer',
                            path: 'ref_lead_customer',
                            attributes: ['phone', 'full_name', 'address.county'],
                            include: [
                                {
                                    model: 'County_list',
                                    path: 'address.county',
                                    attributes: ['name'],
                                }],
                        },
                        {
                            model: 'Lead_source',
                            path: 'ref_lead_source',
                            attributes: ['abbr', 'name'],
                        },
                        {
                            model: 'User',
                            path: 'ref_assigned_to',
                            attributes: ['person.first_name', 'person.last_name', 'person.photos.small'],
                        },
                        {
                            model: 'Lead_affiliate',
                            path: 'ref_lead_affiliate',
                            attributes: ['name'],
                        },
                    ],
                    where,
                },
            },
        )
        .then(response => response)
        .catch(error => error);
};


export const getCustomersId = customer => api.send({
    api: 'db',
    model: 'Lead_customer',
    action: 'Read',
    options: {
        attributes: ['_id'],
        where: {
            $or: [
                {
                    phone: {
                        $regex: customer,
                        $options: 'mi',
                    },
                },
                {
                    email: {
                        $regex: customer,
                        $options: 'mi',
                    },
                },
                {
                    full_name: {
                        $regex: customer,
                        $options: 'mi',
                    },
                },
            ],
        },
    },
});


export const getCustomersPostcode = (postcode) => {
    return api.send({
        api: 'db',
        model: 'Lead_customer',
        action: 'Read',
        options: {
            attributes: ['_id'],
            where: {
                'address.post_code': {
                    $regex: postcode,
                    $options: 'mi',

                },
            },
        },
    });
};

export const getBikes = (params) => {
    // possible params: vrm, bikeBrand, bikeModel, bikeVariantsId
    let vrm;

    if (params.vrm) {
        vrm = {
            $regex: params.vrm,
            $options: 'i',
        };
    } else {
        vrm = undefined;
    }

    return api.send({
        api: 'db',
        model: 'Bike_lead',
        action: 'Read',
        options: {
            attributes: ['_id'],
            where: {
                vrm,
                ref_bike_brand: params.ref_bike_brand,
                ref_bike_model: params.ref_bike_model,
                ref_bike_variant: params.ref_bike_variant,
            },
        },
    });
};

export const getBikeVariantsIsHot = is_hot => api
    .send({
        api: 'db',
        model: 'Bike_variant',
        action: 'Read',
        options: {
            where: {
                is_hot,
            },
        },
    })
    .then(response => response)
    .catch(error => error);


export const getManagerLeadsCount = where => api
    .send({
        api: 'db',
        model: 'Lead',
        action: 'Count',
        options: {
            where,
        },
    })
    .then(response => response)
    .catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/requests/get_manager_leads_request.js